export default "__VITE_PUBLIC_ASSET__b78a7267__"